// O Google aceita no máximo 750 caracteres na descrição da ficha. Acima disso responde só
// "Request contains an invalid argument" (STRING_TOO_LONG): foi o caso da Ock Burger em
// 03/11/2026, com 786 caracteres, enquanto o editor dizia "até 2.000".
export const LIMITE_DESCRICAO_GOOGLE = 750;

/** Mensagem para quem tenta salvar descrição longa demais; null se cabe. */
export const avisoDescricaoLonga = (texto: string | null | undefined): string | null => {
  const tamanho = (texto || "").length;
  if (tamanho <= LIMITE_DESCRICAO_GOOGLE) return null;
  const sobra = tamanho - LIMITE_DESCRICAO_GOOGLE;
  return `A descrição tem ${tamanho.toLocaleString("pt-BR")} caracteres e o Google aceita no máximo ${LIMITE_DESCRICAO_GOOGLE}. Corte ${sobra.toLocaleString("pt-BR")} ${sobra === 1 ? "caractere" : "caracteres"} e salve de novo.`;
};
